





















import Vue from 'vue';

import faq from '../data/faq.json';

import Title from './Title.vue';

type Data = {
  faq: {
    title: string;
    text: string;
  }[];
};

export default Vue.extend({
  name: 'Faq',
  components: {
    Title,
  },
  data(): Data {
    return {
      faq: faq[process.env.VUE_APP_PHASE],
    };
  },
});
